import { environment } from '@et/environment';

/** Origins for which the OAuth interceptor attaches `Authorization: Bearer` (replaces MSAL `protectedResourceMap`). */
export function buildOAuthAllowedResourceOrigins(
  env: typeof environment,
): string[] {
  const raw: Array<string | undefined> = [
    env.apiServer.domain,
    env.docio.domain,
    env.apiDocPrep.domain,
    env.apiOrders.domain,
    env.apiSecureLinks.domain,
    env.auditService.domain,
    env.adminAPI.domain,
    env.packetService.domain,
    env.docPrepService.domain,
    env.docPrepService.domain_mono,
    env.profilev2.domain,
    env.nnaScheduler.domain,
    env.pusher.channelAuthorizationEndpoint,
  ];
  const out = new Set<string>();
  for (const u of raw) {
    const trimmed = u?.trim();
    if (!trimmed?.startsWith('http')) continue;
    try {
      out.add(new URL(trimmed).origin);
    } catch {
      /* skip invalid */
    }
  }
  return [...out];
}
